<template>
  <div>
    <SmartTitle
      heading="1"
      weight="medium"
    >Importação em massa</SmartTitle>
    <div class="flex align-center my-2">
      <form class="flex justify-start mx-1">
        <VSelect
          :items="type"
          placeholder="Tipo de Importação"
          item-text="name"
          item-value="type"
          v-model="typeSelected"
          class="lg:col-8"
        >
          <template v-slot:item="{ item }">
            <div class="v-list__tile__content">
              <div :id="`type-${type.indexOf(item)}`" class="v-list__tile__title">{{ item.name }}</div>
            </div>
          </template>
        </VSelect>
      </form>
      <div class="mx-1 flex" v-if="showDateSelec">
        <VSelect
          :items="months"
          v-model="monthSelected"
          item-text="text"
          item-value="value"
          class="lg:col-5"
          label="Mês"
        >
          <template v-slot:item="{ item }">
            <div class="v-list__tile__content">
              <div :id="`month-${months.indexOf(item)}`" class="v-list__tile__title">{{ item.text }}</div>
            </div>
          </template>
        </VSelect>
        <VSelect
          :items="years"
          v-model="yearSelected"
          item-text="text"
          item-value="value"
          class="lg:col-5"
          label="Mês"
        >
          <template v-slot:item="{ item }">
            <div class="v-list__tile__content">
              <div :id="`year-${years.indexOf(item)}`" class="v-list__tile__title">{{ item }}</div>
            </div>
          </template>
        </VSelect>
      </div>

      <div>
        <SmartButton
          secondary
          @click="$router.push({name: 'ImportationStatus'})"
          class="mr-2"
        >Status importação</SmartButton>
      </div>
      <div>
        <SmartButton
          quaternary
          :disabled="disabledDownloadButton"
          @click="modelDownload"
        >Baixar Modelo</SmartButton>
      </div>
    </div>
    <div>
      <form class="relative">
        <input
          name="file"
          type="file"
          id="real-file"
          class="w-full absolute pl-1-2 pt-1-2"
          @change="alterValueInput"
        />
        <label
          for="real-file"
          class="input-file flex flex-col align-center justify-center border-default rounded cursor-pointer"
        >
          <SmartIcon
            :size="2"
            name="paperclip"
            class="mr-1-2 mb-2"
            id="custom-button"
          />
          <smartP class="value-file-input text-black font-medium relative">{{ fileUploaded ? fileUploaded.name : 'Arraste um arquivo CSV ou clique para procurar' }}</smartP>
        </label>
        <div class="flex justify-end mt-4">
          <router-link to>
            <SmartButton
              @click="verifySendStatus"
              :disabled="disabledUploadButton"
            >Enviar Arquivo</SmartButton>
          </router-link>
          <SmartModal
            v-if="modal"
            v-bind="modal"
            @close.prevent="modal = null"
            @event.prevent="goToImportStatus"
          >{{ modal.text }}</SmartModal>
          <SmartModal
            v-if="infoReloadDataModal"
            v-bind="infoReloadDataModal"
            @close.prevent="infoReloadDataModal = null"
            @event.prevent="continueSend"
          >{{ infoReloadDataModal.text }}</SmartModal>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from 'tim-api';
import moment from 'moment';
import { downloadCsvFile } from 'utils/blob';

const months = [
  { value: 0, text: 'Selecione um mês' },
  { value: 1, text: 'Janeiro' },
  { value: 2, text: 'Fevereiro' },
  { value: 3, text: 'Março' },
  { value: 4, text: 'Abril' },
  { value: 5, text: 'Maio' },
  { value: 6, text: 'Junho' },
  { value: 7, text: 'Julho' },
  { value: 8, text: 'Agosto' },
  { value: 9, text: 'Setembro' },
  { value: 10, text: 'Outubro' },
  { value: 11, text: 'Novembro' },
  { value: 12, text: 'Dezembro' }
];

export default {
  data() {
    return {
      months,
      fileUploaded: '',
      fileValue: '',
      dragging: false,
      type: [],
      typeSelected: '',
      file: '',
      modal: null,
      infoReloadDataModal: null,
      monthSelected: 0,
      yearSelected: moment().year()
    };
  },
  watch: {
    typeSelected() {
      this.file = '';
      this.fileValue = '';
      this.fileUploaded = '';
    }
  },
  mounted() {
    this.fetchFrequenciaEnvio();
  },
  methods: {
    alterValueInput(event) {
      // eslint-disable-next-line
      this.fileUploaded = event.target.files[0];
      this.fileValue = document.getElementById('real-file').value;
    },

    fetchFrequenciaEnvio() {
      api.get('auditoria/frequenciaenvio').then(({ data }) => {
        this.type = data.data.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
        this.loading = false;
      });
    },
    verifySendStatus() {
      const importMode = this.type.find(item => item.type === this.typeSelected);

      if (importMode && importMode.status === 'OK') {
        this.infoReloadDataModal = {
          type: 'warning',
          title: 'Ops!',
          icon: 'alert',
          thirdButton: 'Cancelar',
          fourthButton: 'Continuar',
          text: 'O envio deste arquivo pode acarretar em sobreposição dos dados'
        };
        return false;
      }
      return this.fileUpload();
    },
    continueSend() {
      this.infoReloadDataModal = null;
      this.fileUpload();
    },
    fileUpload() {
      this.file = new FormData();
      this.file.set('file', this.fileUploaded, this.fileUploaded.name);
      switch (this.typeSelected) {
      case 'SimcardImport':
        this.showLoadModal();
        api
          .post('/sigtim/import/faturamentochip/', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Faturamento Chip Envidado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'fatdetImport':
        this.showLoadModal();
        this.file.set('mes', this.monthSelected);
        this.file.set('ano', this.yearSelected);
        api
          .post('/sigtim/import/fatrecargadbservcel', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Meta Faturamento Recarga Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'metagrossImport':
        this.file.set('mes', this.monthSelected);
        this.file.set('ano', this.yearSelected);
        this.showLoadModal();
        api
          .post('/sigtim/import/metagross', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Meta Gross Envidado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'metaGrossRecargaImport':
        this.showLoadModal();
        this.file.set('mes', this.monthSelected);
        this.file.set('ano', this.yearSelected);
        api
          .post('/sigtim/import/metagrosscomrecarga30d', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Meta Gross com recarga 30D Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;
      case 'metafaturamentoImport':

        this.showLoadModal();
        this.file.set('mes', this.monthSelected);
        this.file.set('ano', this.yearSelected);
        api
          .post('/sigtim/import/metafaturamentorecar', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Meta Gross com recarga 30D Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'MartketingShareImportable':
        this.showLoadModal();
        this.file.set('mes', this.monthSelected);
        this.file.set('ano', this.yearSelected);
        api
          .post('/sigtim/import/mktshare', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'MKT Share Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'estoquerecargadbdiaImport':
        this.showLoadModal();
        api
          .post('/sigtim/import/recargadia', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Recarga Dia Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'saldoservceldbImport':
        this.showLoadModal();
        api
          .post('/sigtim/import/saldoservceldb', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Saldo SERVCEL DB Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados cadastrados com sucesso.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'tiservcelImport':
        this.showLoadModal();
        api
          .post('/sigtim/import/recargasservcel', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Recargas SERVCEL Importado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados cadastrados com sucesso.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;

      case 'UserSigtimImport':
        this.showLoadModal();
        api
          .post('/sigtim/import/user', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Usuários Criados',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os usuários cadastrados com sucesso.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;
      case 'CargaDbImportable':
        this.showLoadModal();
        api
          .post('/sigtim/import/distribuidores', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Distribuidor Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;
      case 'AtivacaoChipImport':
        this.showLoadModal();
        api
          .post('/sigtim/import/ativacaochip', this.file, {
            responseType: 'blob/json'
          })
          .then(() => {
            this.modal = {
              type: 'success',
              title: 'Ativação de Chipe Enviado',
              icon: 'accepted',
              buttonText: 'Ok',
              fourthButton: 'Status de importação',
              text:
                  'Pronto! Seu arquivo foi enviado e os dados estão sendo processados.'
            };
          })
          .catch((data) => {
            const dataStatusError = data && data.status === 400;
            const statusImport = dataStatusError ? 'Status de importação' : '';
            this.modal = {
              type: dataStatusError ? 'warning' : 'danger',
              title: 'Ops!',
              color: dataStatusError ? 'warning' : 'danger',
              icon: dataStatusError ? 'alert' : 'refused',
              thirdButton: 'Fechar',
              fourthButton: statusImport,
              text: data && data.data.message
            };
          });
        break;
      default:
        this.modal = {
          type: 'warning',
          title: 'Ops',
          icon: 'warning',
          thirdButton: 'Fechar',
          text: 'Selecione o tipo de Importação'
        };
      }
    },
    showLoadModal() {
      this.modal = {
        type: 'default',
        title: 'Carregando Arquivo...',
        icon: 'union',
        text: 'Estamos subindo o arquivo, aguarde um instante...'
      };
    },
    tryFileUploadAgain() {
      this.fileUpload();
    },
    goToImportStatus() {
      this.$router.push({ name: 'ImportationStatus' });
    },
    modelDownload() {
      const currentDate = moment().format('Do_MM_YYYY, h:mm:ss a');
      switch (this.typeSelected) {
      case 'UserSigtimImport':
        api
          .get('/sigtim/import/user', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'SimcardImport':
        api
          .get('/sigtim/import/faturamentochip', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'fatdetImport':
        api
          .get('sigtim/import/fatrecargadbservcel', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'metagrossImport':
        api
          .get('/sigtim/import/metagross', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'metaGrossRecargaImport':
        api
          .get('/sigtim/import/metagrosscomrecarga30d', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;
      case 'metafaturamentoImport':
        api
          .get('/sigtim/import/metafaturamentorecar', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'MartketingShareImportable':
        api
          .get('/sigtim/import/mktshare', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'estoquerecargadbdiaImport':
        api
          .get('/sigtim/import/recargadia', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'saldoservceldbImport':
        api
          .get('/sigtim/import/saldoservceldb', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'tiservcelImport':
        api
          .get('/sigtim/import/recargasservcel', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'CargaDbImportable':
        api
          .get('/sigtim/import/distribuidores', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      case 'AtivacaoChipImport':
        api
          .get('/sigtim/import/ativacaochip', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
        break;

      default:
        api
          .get('/import/user_sigtim', { responseType: 'blob' })
          .then((response) => {
            downloadCsvFile({ filename: `${this.typeSelected}_${currentDate}`, file: response.data });
          });
      }
    }
  },
  computed: {
    showDateSelec() {
      return !!['metagrossImport', 'metaGrossRecargaImport', 'metafaturamentoImport', 'MartketingShareImportable', 'fatdetImport'].includes(this.typeSelected);
    },
    years() {
      const year = moment().year();
      return [year - 1, year, year + 1];
    },
    disabledDownloadButton() {
      return !this.typeSelected;
    },
    disabledUploadButton() {
      if (!this.fileUploaded) {
        return true;
      }
      if (this.showDateSelec) {
        return this.monthSelected === 0;
      }

      return !this.typeSelected;
    }
  }
};
</script>

<style scoped>
</style>

<style lang="scss">
.value-file-input {
  font-size: $font-size-default;
  opacity: $font-opacity-hg;
}
.input-file {
  border: $border-width-default dashed $color-ui-gradient-gray;
  height: 25rem;
}
.v-input.v-select {
  margin-left: 0;
}
#real-file {
  height: 25rem;
  font-size: 0;
  &::before {
    content: "";
    height: 19px;
    width: 19px;
    position: absolute;
    background: #fafcfe;
  }
}
</style>
